import './MainNavigation.css';
import { NavLink } from 'react-router-dom';

const MainNavigation = ()=>{



    return(
        <header className='header'>
            <div className='logo'>Quotes</div>
            <nav className='nav'>
                <ul>
                    <li>
                        <NavLink to='/quotes' activeClassName='active'>All Qoutes</NavLink>
                    </li>
                    <li>
                        <NavLink to='/new-quote' activeClassName='active'>Add Quotes</NavLink>
                    </li>
                </ul>
            </nav>
        </header>
    )
}


export default MainNavigation;